import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRibbon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 18",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 0H2C0.9 0 0.0100002 0.9 0.0100002 2L0 18L7 15L14 18V2C14 0.9 13.1 0 12 0Z" })
});
export default SvgRibbon;
